import React, { useState, useContext, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom'; // Added Link for Signup navigation
import { AuthContext } from '../context/AuthContext';
import { motion} from "framer-motion"
import { ToastContainer,toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import API from '../services/api';
const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false); // Loading state for handling loader
  const { user, login } = useContext(AuthContext);
  const navigate = useNavigate();
  
 
  useEffect(() => {
    // Redirect to dashboard if user is already logged in
    if (user) {
      navigate('/dashboard/profile');
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loading
   
    try {
     const response = await API.post(`${process.env.REACT_APP_API_URL}/api/login`, { email, password });
      login(response.data.token);
      navigate('/dashboard/'); // Redirect to dashboard after successful login
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick:true,
        pauseOnHover:true,
        draggable:true,
        progress:undefined,
        theme:'dark'
      });
      console.error('Login failed', error);
    } finally {
      setLoading(false); // Stop loading
    }
  };
  

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{
        duration: 0.6,
        ease: "easeInOut",
        exit: {
          duration: 1,
          ease: "easeInOut",
        },
      }}
      className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-cyan-50 py-12 px-4 sm:px-6 lg:px-8"
    >
      <div className="bg-white shadow-xl rounded-2xl p-8 max-w-md w-full border border-gray-100">
        {/* Logo and Clinic Info */}
        <div className="text-center mb-8">
          <div className="mb-4">
            <img
              src="/logo.png" // Assuming logo.png is in the public folder
              alt="Dental Clinic Logo"
              className="mx-auto h-16 w-auto object-contain"
              onError={(e) => {
                // Fallback if logo doesn't exist
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
            {/* Fallback dental icon if logo doesn't load */}
            <div className="hidden mx-auto h-16 w-16 bg-blue-100 rounded-full items-center justify-center">
              <svg className="h-8 w-8 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 000 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
              </svg>
            </div>
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            KodeKalp Global Technologies
          </h1>
          <p className="text-sm text-gray-600 mb-6">
            Please sign in to access your dashboard
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
              Email Address
            </label>
            <input
              id="email"
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors duration-200"
              required
            />
          </div>
          
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
              Password
            </label>
            <input
              id="password"
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors duration-200"
              required
            />
          </div>

          <div className="text-right">
            <Link
              to="/forgot-password"
              className="text-blue-600 font-medium hover:text-blue-700 hover:underline transition-colors duration-200 text-sm"
            >
              Forgot your password?
            </Link>
          </div>

          <button
            type="submit"
            className="w-full px-4 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200 disabled:opacity-70 disabled:cursor-not-allowed"
            disabled={loading}
          >
            {loading ? (
              <div className="flex items-center justify-center">
                <svg
                  className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                  ></path>
                </svg>
                Signing in...
              </div>
            ) : (
              "Sign In"
            )}
          </button>

          <div className="text-center mt-6 pt-4 border-t border-gray-200">
            <span className="text-gray-600 text-sm">Don't have access? </span>
            <Link
              to="/signup"
              className="text-blue-600 font-medium hover:text-blue-700 hover:underline transition-colors duration-200"
            >
              New Client Signup
            </Link>
          </div>
        </form>

        {/* Additional dental clinic info */}
        <div className="mt-8 pt-6 border-t border-gray-100 text-center">
          <p className="text-xs text-gray-500">
            For technical support, contact IT at{" "}
            <a href="mailto:support@kodekalp.com" className="text-blue-600 hover:underline">
              support@kodekalp.com
            </a>
          </p>
        </div>
      </div>
      
      <ToastContainer
        position="top-center"
        theme="colored"
        className="mt-16"
      />
    </motion.div>
  );
};

export default Login;
